var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisionBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1006.064,
    height: 769.586,
    viewBox: "0 0 1006.064 769.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-914 -2288.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599,0c157.139,0,300.145,28.335,406.824,74.617.158,60.594-.119,332.664.24,411.662C899.145,532.665,756.139,561,599,561,268.181,561,0,435.416,0,280.5S268.181,0,599,0Z",
    transform: "translate(914 2497)",
    fill: "#0b875c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "visionTree5",
    transform: "translate(1793.971 2604.587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.084,84.257H70.233V225.762Z",
    transform: "translate(-8.517 -34.604)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.514,0,29.53,52.617h9.076L22.527,87.889H33.051L12.124,133.8H26.146L0,191.158H53.514Z",
    transform: "translate(0)",
    fill: "#086945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V191.158h53.515L90.571,133.8h14.021L83.666,87.889H94.189L78.111,52.617h9.074Z",
    transform: "translate(-9.687)",
    fill: "#09603f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visionTree3",
    transform: "translate(1498.089 2433.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.57,225.762l.109,98.023H74.6V225.762Z",
    transform: "translate(5.499 22.338)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.455,0,38.326,68.291h11.78L29.237,114.069H42.9l-27.16,59.587h18.2L0,248.1H69.455Z",
    transform: "translate(0)",
    fill: "#086945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V248.1h69.455L98.724,173.656h18.2L89.762,114.069H103.42L82.552,68.291H94.329Z",
    transform: "translate(6.254)",
    fill: "#09603f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visionTree4",
    transform: "translate(1597.082 2288.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.571,225.762l.2,109.745H89.875V225.762Z",
    transform: "translate(54.514 221.467)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.2,0,69.088,123.1H90.322L52.7,205.623H77.325L28.365,313.036h32.8L0,447.229H125.2Z",
    transform: "translate(0)",
    fill: "#086945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V447.229H188.4L127.235,313.036h32.8L111.08,205.623H135.7L98.083,123.1h21.23Z",
    transform: "translate(62)",
    fill: "#09603f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visionTree2",
    transform: "translate(1072.456 2428.793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.571,225.762l.059,55.442H65.857V225.762Z",
    transform: "translate(-22.56 -91.652)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.544,0,20.717,36.914h6.367L15.8,61.66h7.383L8.506,93.87h9.837L0,134.11H37.544Z",
    transform: "translate(0)",
    fill: "#086945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V134.11h37.544L82.4,93.87H92.24L77.559,61.66h7.383L73.661,36.914h6.366Z",
    transform: "translate(-25.657)",
    fill: "#09603f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "visionTree1",
    transform: "translate(954 2288.414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.571,225.762l.114,63.991H75.47V225.762Z",
    transform: "translate(8.288 33.669)",
    fill: "#736357"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.627,0,40.077,71.41H52.394l-21.822,47.87H44.855l-28.4,62.308h19.03L0,259.431H72.627Z",
    transform: "translate(0)",
    fill: "#086945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,0V259.431h72.628l-35.483-77.844h19.029l-28.4-62.308h14.281L83.436,71.41H95.751Z",
    transform: "translate(9.426)",
    fill: "#09603f"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionBottom);
export default __webpack_public_path__ + "static/media/vision-bottom.fd603ef6f89b49f1af23be852701d718.svg";
export { ForwardRef as ReactComponent };